import { State } from '@autopylot-internal/state';
import { FleetManagementState } from './FleetManagementState.ts';
import { AircraftResponse } from './FleetManagmentClient.ts';
import { TrackingService } from '../support/tracking/TrackingService.ts';

export class AircraftPickerState extends State<Record<string, never>> {

    static inject = () => [FleetManagementState, TrackingService];
    constructor(private fleetState: FleetManagementState, private tracker: TrackingService){
        super({ });
        this.fleetState.subscribe(() => this.setState({ }));
    }
    isOpen = false;
    missionId = '';

    show = (missionId: string) => {
        this.isOpen = true;
        this.missionId = missionId;
        this.setState({ });
    };

    hide = () => {
        this.isOpen = false;
        this.missionId = '';
        this.setState({ });
    };

    getFleet = () => {
        const active = this.fleetState.fleet.filter(a => a.status === 'active').sort(this.fleetState.activeSort);
        const grounded = this.fleetState.fleet.filter(a => a.status === 'grounded').sort(this.fleetState.alphaSort);
        const flyingArchived = this.fleetState.fleet.filter(a => a.status === 'archived' && a.missions.includes(this.missionId)).sort(this.fleetState.alphaSort);
        return [
            ...active,
            ...grounded,
            ...flyingArchived
        ];
    };

    getNonFlyingArchived = () => {
        return this.fleetState.fleet.filter(a => a.status === 'archived' && !a.missions.includes(this.missionId));
    };

    hasArchived = () => {
        return this.fleetState.fleet.some(a => a.status === 'archived');
    };

    hasNonFlyingArchived = () => {
        return this.fleetState.fleet.some(a => a.status === 'archived' && !a.missions.includes(this.missionId));
    };

    toggleAircraft = (aircraft: AircraftResponse) => {
        if (!this.isAircraftFlying(aircraft)){
            this.fleetState.assignAircraftToMission({ aircraft, missionId: this.missionId });
            this.tracker.track('Equipment Added to Mission', () => ({
                equipmentType: 'Drone',
                equipmentMake: aircraft.make,
                equipmentModel: aircraft.model
            }));
        }
        else {
            this.fleetState.removeAircraftFromMission({ aircraft, missionId: this.missionId });
            this.tracker.track('Equipment Removed from Mission', () => ({
                equipmentType: 'Drone',
                equipmentMake: aircraft.make,
                equipmentModel: aircraft.model
            }));
        }
    };

    isAircraftFlying = (aircraft: AircraftResponse) => {
        return aircraft.missions.includes(this.missionId);
    };

    addAircraft = () => {
        this.fleetState.startAddingAircraft(aircraft => {
            this.toggleAircraft(aircraft);
        });
    };
}
